import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { HelpCircle } from "lucide-react";

export const CalcPopover = ({ title, lines, testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" className="inline-flex items-center text-gray-400 hover:text-emerald-600 align-middle ml-1" aria-label="Como foi calculado?" data-testid={testId} onClick={(e) => e.stopPropagation()}>
        <HelpCircle className="h-3.5 w-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent className="w-80 text-xs" onClick={(e) => e.stopPropagation()}>
      <p className="font-semibold text-gray-800 mb-2">📐 {title}</p>
      <div className="space-y-1">
        {lines.map((l, i) => (
          <p key={i} className={l && l.startsWith("=") ? "font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded px-2 py-1" : "text-gray-600"}>{l}</p>
        ))}
      </div>
    </PopoverContent>
  </Popover>
);
